export default "__VITE_ASSET__BSdxSt9n__"